import * as trace from 'owa-trace';
import getFolderNodeViewState from '../selectors/getFolderNodeViewState';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import OwaUserConfiguration from 'owa-service/lib/contract/OwaUserConfiguration';
import updateFolderViewStateService from '../services/updateFolderViewStateService';
import { updateUserConfiguration } from 'owa-session-store/lib/actions/updateUserConfiguration';
import getNewOrModifiedFolderViewState, {
    FolderViewState,
} from './getNewOrModifiedFolderViewState';

/**
 * Utility function which decides to update or add modified FolderViewState to user config.
 * @param folderId folderId
 */
export default function updateFolderViewState(folderId: string) {
    const folderViewStateFromUserConfig =
        getUserConfiguration().ViewStateConfiguration.FolderViewState || [];
    const folderViewStateFromStore = getFolderNodeViewState(folderId);
    let isDirty: boolean = false;
    let existingUserConfigFolderViewState: FolderViewState = null;
    let index: number = -1;

    try {
        for (let i = 0; i < folderViewStateFromUserConfig.length; i++) {
            const userConfigFolderViewState: FolderViewState = JSON.parse(
                folderViewStateFromUserConfig[i]
            );

            // Just save the index in case of an update
            if (userConfigFolderViewState.FolderId.Id === folderId) {
                existingUserConfigFolderViewState = userConfigFolderViewState;
                index = i;
                break;
            }
        }

        const folderViewStateToSave = getNewOrModifiedFolderViewState(
            folderId,
            existingUserConfigFolderViewState,
            folderViewStateFromStore
        );

        if (!folderViewStateToSave) {
            return;
        }

        // If found, then update if IsExpanded property does not match
        if (index !== -1) {
            isDirty =
                existingUserConfigFolderViewState.IsExpanded !== folderViewStateToSave.IsExpanded;
            // Update if it is dirty
            if (isDirty) {
                updateUserConfiguration(userConfig => {
                    const folderViewStateFromUserConfig =
                        userConfig.ViewStateConfiguration.FolderViewState || [];
                    folderViewStateFromUserConfig[index] = JSON.stringify(folderViewStateToSave);
                });
            }
        } else {
            // Need to save new view state configuration to user config
            isDirty = true;
            updateUserConfiguration(userConfig => {
                const folderViewStateFromUserConfig =
                    userConfig.ViewStateConfiguration.FolderViewState || [];
                folderViewStateFromUserConfig.push(JSON.stringify(folderViewStateToSave));
            });
        }
    } catch (e) {
        trace.errorThatWillCauseAlert(
            'Error encountered while updating folderViewState' + e.message
        );
    }

    if (isDirty) {
        updateFolderViewStateService(getUserConfiguration() as OwaUserConfiguration);
    }
}

export function updateFolderViewStateUsingUserConfig(
    folderId: string,
    config: OwaUserConfiguration
) {}
